<template>
    <ul class="list--unstyled">
        <li class="sidebar-favorites__section-title">
            {{ $t('tournaments') | upperCase }} ({{ count }})
        </li>
        <li
            v-for="tournament in tournaments"
            :key="tournament.id"
            @click="onClick(tournament)"
            class="sidebar-nav__item-wrapper"
        >
            <div class="sidebar-nav__item">
                <span>{{ tournament.displayName }}</span>
                <span
                    @click="onRemoveClick(tournament)"
                    class="sidebar-nav__remove-icon"
                >
                    <i class="icon--sm icon-close"></i>
                </span>
            </div>
        </li>
    </ul>
</template>

<script>
    import { SECTION_ID_PREFIX } from '@app/modules/eventGrid/gridUnits/Section';
    import { getElementHeights } from '@app/modules/eventGrid/constants';
    import { NAVBAR_HEIGHT, NAVBAR_MARGIN } from '@app/styles/elementConstants';

    export default {
        name: 'Tournaments',
        props: {
            tournaments: {
                type: Array,
                required: true,
            },
        },
        computed: {
            count() {
                return this.tournaments.length;
            },
        },
        methods: {
            onClick(item) {
                const heights = getElementHeights().normal;
                const offset = NAVBAR_HEIGHT + NAVBAR_MARGIN + heights.categoryHeader;

                const tournamentSectionId = `#${SECTION_ID_PREFIX}${item.id}`;

                this.$scrollTo(tournamentSectionId, {
                    offset: -1 * offset,
                });
            },
            onRemoveClick(item) {
                this.$emit('removeClick', item);
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/sportOffer/favourites/sidebar/components/Tournaments.vue